<div *ngIf="display">
    <header class="header header-6 theme-container"  style="position: fixed;z-index: 10;">

         <div  fxLayout="row" style="background-color: #AD8B3A;">
            <!-- <div fxFlex="20">
                <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>

            </div> -->
            <div fxLayout="row" style="width: 100%;">
                <!-- <div fxFlex="5"></div> -->
                <div fxFlex fxLayout="row" >
                    <div fxFlex="20" class="rigth" style="color: white;" fxLayoutAlign="center center" >
                        <a href="https://www.webotel.co.in/home"  class="padding-10">
                            <div fxLayout="row" fxLayoutGap="10px"  >
                                <div fxLayoutAlign="center center">
                                    <mat-icon>domain</mat-icon>
                                </div>
                                <div>
                                    <h3>List Your Property</h3>
                                    <!-- <p>Additional 10% off on stays</p> -->
                                </div>
                            </div>
                           
                        </a>
                       
                    </div>
                    <div fxFlex="20" class="rigth" style="color: white;" fxLayoutAlign="center center" >
                        <a href="https://www.roohihotels.com/pages/rewards" class="padding-10">
                            <div fxLayout="row" fxLayoutGap="10px" >
                                <div fxLayoutAlign="center center">
                                    <mat-icon>groups</mat-icon>
                                </div>
                                <div>
                                    <h3>Become a Member</h3>
                                    <!-- <p>Additional 10% off on stays</p> -->
                                </div>
                            </div>
                           
                        </a>
                       
                    </div>
                    <div fxFlex="20" class="rigth" style="color: white;" fxLayoutAlign="center center" >
                        <a href="https://www.webotel.co.in/pages/Subscription"  class="padding-10">
                            <div fxLayout="row" fxLayoutGap="10px" >
                                <div fxLayoutAlign="center center">
                                    <mat-icon>subscriptions</mat-icon>
                                </div>
                                <div>
                                    <h3>Subscribe Now</h3>
                                    <!-- <p>Additional 10% off on stays</p> -->
                                </div>
                            </div>
                           
                        </a>
                       
                    </div>
                    <div fxFlex="20" class="rigth" style="color: white;" fxLayoutAlign="center center" >
                        <a href="https://www.roohihotels.com/pages/EVENTSANDMICES"  class="padding-10">
                            <div fxLayout="row" fxLayoutGap="10px" >
                                <div fxLayoutAlign="center center">
                                    <mat-icon>corporate_fare</mat-icon>
                                </div>
                                <div>
                                    <h3>Corporate Inquiry</h3>
                                    <!-- <p>Additional 10% off on stays</p> -->
                                </div>
                            </div>
                           
                        </a>
                       
                    </div>
                    <div fxFlex="20" style="color: white;"   fxLayoutAlign="center center" >
                        <a href="https://www.roohihotels.com/pages/Wedding"  class="padding-10">
                            <div fxLayout="row" fxLayoutGap="10px" >
                                <div fxLayoutAlign="center center">
                                    <mat-icon>church</mat-icon>
                                </div>
                                <div>
                                    <h3>Wedding Inquiry</h3>
                                    <!-- <p>Additional 10% off on stays</p> -->
                                </div>
                            </div>
                           
                        </a>
                       
                    </div>
                </div>
                
            </div>
            <!-- <div fxFlex="10" style="cursor:pointer ;font-size: 20px;" fxLayoutAlign="center center">
                <div class="login padding-10" style="font-size:20px" *ngIf="languageSelection==1">
                    <calsoft-language></calsoft-language>
                </div>

                <div *ngIf="data.disableLoginHeader==0">
                    <div class="login padding-10" style="font-size:20px" *ngIf="!userLoggedIn" (click)="SignIn('login')">Login</div>
                </div>
                <div *ngIf="data.disableLoginHeader==0">

                <calsoft-HeaderUserProfileDropdown [data]="data"
                    *ngIf="userLoggedIn">
                </calsoft-HeaderUserProfileDropdown>
                </div>
            </div> -->

        </div>


        <div class="header-top" style="background-color: #F5F5F5;">
            <div [class]="containerClass">
                <!-- <div (click)="composeEmail(data.smtpUsername)" class="header-left" style="cursor: pointer;">
                    <mat-icon  class="icon-css">mail</mat-icon>{{data.smtpUsername}}
                </div> -->

                <div fxFlex="5">

                </div>

                <!-- <div class="header-left" style="cursor: pointer;">
                    {{data.headerNotificationContent}}
                </div> -->

                <div class="header-right">
                    <!-- <div *ngIf="showFooterIcon==1">
                        <div>
                            <span *ngFor="let item of footerIconData; let i = index">

                                <button (click)="navigate(item)" mat-icon-button>

                                    <mat-icon [svgIcon]="item.iconName"> </mat-icon>
                                </button>
                            </span>

                        </div>

                    </div> -->

                    <!-- <div class="login padding-10" style="font-size:12px" *ngIf="languageSelection==1">
                        <calsoft-language></calsoft-language>
                    </div> -->

                    <div style="cursor:pointer ;font-size: 12px;" fxLayoutAlign="center center">
                        <div *ngIf="data.disableLoginHeader==0" fxLayout="row" fxLayoutAlign="center center">

                            <mat-icon style="padding-top:10px ;" class="icon-css" (click)="gotoCall()">call</mat-icon>

                            <div class="login padding-10" *ngIf="!userLoggedIn" (click)="SignIn('login')">
                                <p style="font-size: 14px;">Login</p>
                            </div>
                        </div>
                        <div *ngIf="data.disableLoginHeader==0">

                            <calsoft-HeaderUserProfileDropdown [data]="data"
                                *ngIf="userLoggedIn"></calsoft-HeaderUserProfileDropdown>
                        </div>

                    </div>


                </div>
            </div>
        </div>

        <div class="header-middle">
            <div class="containerCss">
                <div fxFlex="1" fxFlex.xs="5" fxFlex.lt-lg="1"></div>
                <div fxFlex="39" fxFlex.xs="40" fxFlex.lt-lg="35"   fxLayoutAlign="center center">
                    <calsoft-Menu [data]="data" style="z-index: 1000;" [type]="'one'"
                        [categoryArray]="list1"></calsoft-Menu>
                </div>
                <div fxFlex="2" fxFlex.lt-lg="4"></div>
                <div fxFlex="10" fxFlex.xs="10" fxFlex.lt-lg="10">
                    <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>
                </div>
                <div fxFlex="2"></div>
                <div fxFlex="39" fxFlex.xs="40" fxFlex.lt-lg="40" fxLayoutAlign="center center">
                    <calsoft-Menu [data]="data" style="z-index: 1000;" [type]="'one'"
                        [categoryArray]="list2"></calsoft-Menu>
                </div>
                <div fxFlex="7" fxFlex.xs="5" fxFlex.lt-lg="10" fxLayoutAlign="center center">
                    <!-- <calsoft-book-popup></calsoft-book-popup> -->
                    <!-- <button class="dropdown-toggle" mat-raised-button color="primary"
                        [style.background]="isOpen ? '#AD8B3A' : '#AD8B3A'" (click)="toggleMenu()" class="btncss">
                        {{ isOpen ? 'CLOSE' : 'BOOK A STAY' }}

                    </button> -->

                    <button (click)="PageNavigation(data.customButtonInCategroyPageNavigation)" [style.background]="'#AD8B3A'" class="dropdown-toggle" mat-raised-button color="primary" class="btncss">
                        Book Now
                    </button>
                </div>
            </div>
        </div>

        <!-- <mat-toolbar fxHide fxShow.md fxShow.gt-md class="calsoft-fixed-header primary" fxLayout="row"
            fxLayoutAlign="space-between center" style="z-index: 1000;">
            <mat-toolbar-row class=" theme-container" style="height: 100%;" fxLayoutAlign="space-between center">
                <div class="header-middle">
                    <div class="containerCss">
                            <div fxFlex="3"></div>
                            <div fxFlex="35" >                    
                                <calsoft-Menu [data]="data" style="z-index: 1000;" [type]="'one'" [categoryArray]="list1"></calsoft-Menu>
                            </div>
                            <div fxFlex="2"></div>
                            <div fxFlex="10">                    
                                <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>
                            </div>
                            <div fxFlex="2"></div>
                            <div fxFlex="35" >                        
                                <calsoft-Menu [data]="data" style="z-index: 1000;" [type]="'one'" [categoryArray]="list2"></calsoft-Menu>
                            </div>
                            <div fxFlex="3"></div>

                            <div fxFlex="10" >                        
                            <button *ngIf="!userLoggedIn" (click)="SignIn('login')" style="line-height: 15px" mat-button>
                                <div style="color: #ffffff" fxLayout="column">
                                    <small>Hello, Sign in</small>
                                    <span>Account & Lists</span>
                                </div>
                            </button>
        
                            <calsoft-HeaderUserProfileDropdown [data]="data" [type]="scroll" class="headerUser"
                                *ngIf="userLoggedIn">
                            </calsoft-HeaderUserProfileDropdown>
                        </div>

                    </div>
                </div>
        
            </mat-toolbar-row>

        </mat-toolbar> -->
    </header>
</div>
<div *ngIf="!display">

    <div *ngIf="mobileHeaderType==1">
        <calsoft-mobile-header [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header>
    </div>

    <div *ngIf="mobileHeaderType==0">
        <calsoft-mobile-header-new [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header-new>
    </div>

    <div *ngIf="mobileHeaderType==2">
        <calsoft-mobile-header3 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header3>
    </div>

    <div *ngIf="mobileHeaderType==3">
        <calsoft-mobile-header4 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header4>
    </div>

    <div *ngIf="mobileHeaderType==4">
        <calsoft-mobile-header5 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header5>
    </div>

    <div *ngIf="mobileHeaderType==5">
        <calsoft-mobile-header6 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header6>
    </div>
    <div *ngIf="mobileHeaderType==6">
        <calsoft-mobile-header7 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header7>
    </div>
    <div *ngIf="mobileHeaderType==7">

        <calsoft-mobile-header8 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header8>
    </div>
    <div *ngIf="mobileHeaderType==8">
        <calsoft-mobile-header9 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header9>
    </div>
</div>
